import { render, staticRenderFns } from "./PalletViewing.vue?vue&type=template&id=bf50ece8&scoped=true&"
import script from "./PalletViewing.vue?vue&type=script&lang=js&"
export * from "./PalletViewing.vue?vue&type=script&lang=js&"
import style0 from "./PalletViewing.vue?vue&type=style&index=0&id=bf50ece8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf50ece8",
  null
  
)

export default component.exports